<template>
  <div>
    <div class="card-body">
      <inputbox
        name="claim_prefix"
        label="Claim Reference Prefix"
        v-model="settings.claim_prefix"
      ></inputbox>
      <inputbox
        name="claim_starting_number"
        label="Claim Reference Starting Number"
        v-model="settings.claim_starting_number"
      ></inputbox>
    </div>
    <div class="card-footer text-right">
      <button class="btn btn-primary" v-on:click.prevent="save">Save</button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    creditHireOrganisation: String
  },

  data() {
    return {
      settings: new window.Form({
        claim_prefix: null,
        claim_starting_number: null
      })
    };
  },

  mounted() {
    if (this.creditHireOrganisation) {
      window.Ajax.get(
        `/credit-hire-organisations/${this.creditHireOrganisation}/settings`
      )
        .then(response => {
          let data = response.data;
          let keys = Object.keys(this.settings.data());

          keys.forEach(key => {
            this.settings[key] = data.find(item => {
              return item.key === key;
            }).value;
          });
        })
        .catch(error => {});
    }
  },

  methods: {
    save() {
      if (this.creditHireOrganisation) {
        this.settings
          .post(
            `/credit-hire-organisations/${this.creditHireOrganisation}/settings`
          )
          .then(response => {
            window.toastify.success(
              'Saved',
              'The settings were saved successfully!'
            );
          })
          .catch(error => {
            window.toastify.error(
              'Error',
              'Sorry, there was an error saving the settings'
            );
          });
      }
    }
  }
};
</script>
